import {
  Directive,
  forwardRef,
  Input
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  Validator
} from '@angular/forms';

import { DATE_CONFIGURATIONS } from '../constants/date.configurations.constant';

@Directive({
  selector : '[worTimeValidator]',
  providers: [
    {
      multi      : true,
      provide    : NG_VALIDATORS,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: forwardRef(() => TimeValidator)
    }
  ]
})
export class TimeValidator implements Validator {
  private _defaultValidation = DATE_CONFIGURATIONS.time.validation;

  @Input('worTimeValidator') value: string;

  validate ( control: AbstractControl ) : { [ key: string ] : any } {
    const value = typeof control.value === 'string'
      ? control.value.trim()
      : control.value;

    if ( !control.value ) {
      return null;
    }

    return ( value && this._defaultValidation.test(value) )
      ? null
      : { time: true };
  }
}